import React from 'react'
import { useState } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom'
import { deleteCustomerAccount, getCustomerAccountsByDateRange } from '../../../action';
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import Loading from '../../../util/Loading'
import { useEffect } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import ReactPaginate from 'react-paginate';

export default function CustomerAccDashboard() {
    TabTitle('Customer Account Dashboard');
    const state = useContext(GlobalState);
    const signInUser = JSON.parse(localStorage.getItem('user_data'));

    //Import customer account states from global state
    const [cusAccountData, setCusAccountData] = useState([]);
    const [customerAccounts] = state.cusAccountAPI.customerAccounts;

    //Import state
    const [rowPerPage] = state.cusAccountAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.cusAccountAPI.pageNumber;
    const [totalPages] = state.cusAccountAPI.totalPages;
    const [setSearch] = state.cusAccountAPI.search;
    const [callback, setCallback] = state.cusAccountAPI.callback;

    //Local value states
    let gotDate = new Date();
    let defaultDate = new Date(gotDate).toISOString().slice(0, 10)
    const [startDate, setStartDate] = useState(defaultDate)
    const [endDate, setEndDate] = useState(defaultDate);
    const [trigger, setTrigger] = useState(false)

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const searchByDateHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);

        setTimeout(() => {
            setTrigger(true);
        }, 1000);

        e.target.name === "start_date" ? setStartDate(e.target.value) : setEndDate(e.target.value);
    }

    const onChangeSearchHandler = (start_date, end_date) => {
        getCustomerAccountsByDateRange(start_date, end_date, rowPerPage, pageNumber, res => {
            setCusAccountData(res);
            setPageNumber(res.totalPages ? res.totalPages : 1)
        })
    }

    const deleteCustomerAccountHandler = (id) => {
        deleteCustomerAccount(id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    const dateConverter = (date) => {
        let convertedDate = new Date(date).toISOString().slice(0, 10);
        return convertedDate
    }

    useEffect(() => {
        setCusAccountData(customerAccounts);
        if (trigger) {
            onChangeSearchHandler(startDate, endDate);
            setTrigger(false);
        }
    }, [rowPerPage, pageNumber, customerAccounts, trigger])
    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Customer Account Details</p>
                    <div className='custom-search'>
                        <input
                            type="date"
                            name="start_date"
                            id="start_date"
                            value={startDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="date"
                            name="end_date"
                            id="end_date"
                            value={endDate}
                            onChange={(e) => searchByDateHandler(e)}
                        />

                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search purchase here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to='/customer-account-form'><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    cusAccountData.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Customer Name</th>
                                        <th>Collected Amount</th>
                                        <th>Collected Date</th>
                                        <th>Collected By</th>
                                        <th>Balance Amount</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        cusAccountData.count > 0 ? cusAccountData.data.map(account => (
                                            <tr key={account.id}>
                                                <td>{account.customer.first_name + " " + account.customer.last_name}</td>
                                                <td>{account.advance_amount}</td>
                                                <td>{dateConverter(account.created_at)}</td>
                                                <td>{account.updated_by.first_name + " " + account.updated_by.last_name}</td>
                                                <td>{account.last_time_balance}</td>
                                                <td>
                                                    <Link to={`/customer-account-form/${account.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    {/* <button><i className="uil uil-eye"></i></button> */}
                                                    <Link to={'#'}></Link>
                                                    <button onClick={() => deleteCustomerAccountHandler(account.id)}><i className="uil uil-trash-alt"></i></button>

                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan={5}>Can not found any purchase details.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
